import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3yerfaqmmt: FaireBrandEntity = {
  token: "b_3yerfaqmmt",
  type: "brand",
  name: "Desesh",
  avatarUrl:
    "https://cdn.faire.com/fastly/ca25804c36588ceed2899307b4c317ec39a68f4ce4666e58a64da1f6c974b6bf.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e4c6d98356fc8b54c0a2013756aeca32e213d4ced7792f88f8a9ede873881610.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ca25804c36588ceed2899307b4c317ec39a68f4ce4666e58a64da1f6c974b6bf.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e4c6d98356fc8b54c0a2013756aeca32e213d4ced7792f88f8a9ede873881610.jpeg",
  location: "Honolulu, HI, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 242,
  isTopShop: true,
  isInsider: true,
  description:
    "We offer a curated collection of plastic-free and low-tox personal care and home essential alternatives. Our mission is to make it easier for more people to make simple sustainable swaps in their everyday routine! All of the non-accessory products that we sell wholesale are made in the USA, vegan and cruelty free, and contain no artificial fragrances or colors. Our accessory products are globally sourced and provide affordable, unbranded, minimally packaged (or no packaging), plastic free swaps for your customers to reduce the environmental impact of their daily routines. All wholesale orders will be shipped from our U.S. mainland warehouse in North Carolina. We offer low order minimums and sell most items either individually or in small case sizes so you can buy as much or as little as you need!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.085Z",
    importedBy: "entity-db-cli",
  },
};
